import { render, staticRenderFns } from "./timeline-item.vue?vue&type=template&id=8ca1121c&"
import script from "./timeline-item.vue?vue&type=script&lang=js&"
export * from "./timeline-item.vue?vue&type=script&lang=js&"
import style0 from "./timeline-item.vue?vue&type=style&index=0&id=8ca1121c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports